import { createContext } from 'react';
import { entityTypeNameFor } from '@shapeable/utils';
export var defaultEntityTypeTargetsSet = {
  Entity: function (entity) {
    return {
      targets: [entity]
    };
  },
  TopicExpertise: function (entity, source) {
    var sourceTypeName = entityTypeNameFor(source);
    if (sourceTypeName === 'Topic') {
      return {
        targets: [entity.person],
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Person') {
      return {
        targets: entity.topics,
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Organisation') {
      return {
        targets: entity.topics,
        source: entity.levelOfExpertise
      };
    }
  },
  TrendExpertise: function (entity, source) {
    var sourceTypeName = entityTypeNameFor(source);
    if (sourceTypeName === 'Trend') {
      return {
        targets: [entity.person],
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Person') {
      return {
        targets: entity.trends,
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Organisation') {
      return {
        targets: entity.trends,
        source: entity.levelOfExpertise
      };
    }
  },
  SdgExpertise: function (entity, source) {
    var sourceTypeName = entityTypeNameFor(source);
    if (sourceTypeName === 'Sdg') {
      return {
        targets: [entity.person],
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Person') {
      return {
        targets: entity.sdgs,
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Organisation') {
      return {
        targets: entity.sdgs,
        source: entity.levelOfExpertise
      };
    }
  },
  ChallengeExpertise: function (entity, source) {
    var sourceTypeName = entityTypeNameFor(source);
    if (sourceTypeName === 'ChallengeExpertise') {
      return {
        targets: [entity.person],
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Person') {
      return {
        targets: entity.challenges,
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Organisation') {
      return {
        targets: entity.challenges,
        source: entity.levelOfExpertise
      };
    }
  },
  KeyIssueExpertise: function (entity, source) {
    var sourceTypeName = entityTypeNameFor(source);
    if (sourceTypeName === 'KeyIssue') {
      return {
        targets: [entity.person],
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Person') {
      return {
        targets: entity.keyIssues,
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Organisation') {
      return {
        targets: entity.keyIssues,
        source: entity.levelOfExpertise
      };
    }
  },
  SubTopicExpertise: function (entity, source) {
    var sourceTypeName = entityTypeNameFor(source);
    if (sourceTypeName === 'SubTopic') {
      return {
        targets: [entity.person],
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Person') {
      return {
        targets: entity.subTopics,
        source: entity.levelOfExpertise
      };
    }
    if (sourceTypeName === 'Organisation') {
      return {
        targets: entity.subTopics,
        source: entity.levelOfExpertise
      };
    }
  },
  SpaceMembership: function (entity, source) {
    var sourceTypeName = entityTypeNameFor(entity);
    if (sourceTypeName === 'SpaceMembership') {
      return {
        targets: [entity.person],
        source: entity.role
      };
    }
    // if (sourceTypeName === 'Person') {
    //   return {
    //     targets: entity.spaces,
    //     source: entity.role,
    //   }
    // }
  },
  OrganisationSpaceMembership: function (entity, source) {
    var sourceTypeName = entityTypeNameFor(entity);
    if (sourceTypeName === 'OrganisationSpaceMembership') {
      return {
        targets: [entity.organisation],
        source: entity.role
      };
    }
    // if (sourceTypeName === 'Organisation') {
    //   return {
    //     targets: entity.spaces,
    //     source: entity.role,
    //   }
    // }
  },
  EventRole: function (entity, source) {
    var sourceTypeName = entityTypeNameFor(source);
    if (sourceTypeName === 'Person') {
      return {
        targets: [entity === null || entity === void 0 ? void 0 : entity.event],
        source: entity === null || entity === void 0 ? void 0 : entity.role
      };
    }
  }
};
export var EntityTypeValueTargetsContext = createContext(defaultEntityTypeTargetsSet);
export var EntityTypeValueTargetsProvider = EntityTypeValueTargetsContext.Provider;